import React from 'react';
import { t } from '../../../i18n';
import i18n from '../../../i18n';
import type { DeliveryMethodI18nItemType } from '../../../graphql/queries/getDeliveryMethodI18nConfig';

const getDeliveryMethodLabelFromConfig = (item: DeliveryMethodI18nItemType): string => {
    const raw = (i18n.language || '').toLowerCase();
    const lang = raw.includes('zh') ? 'zh' : raw.includes('es') ? 'es' : 'en';
    return (item[lang] || item.en) ?? item.code;
};

export interface DeliveryMethodDisplayCardProps {
    item: DeliveryMethodI18nItemType;
    className?: string;
}

const DeliveryMethodDisplayCard: React.FC<DeliveryMethodDisplayCardProps> = ({
    item,
    className = ''
}) => {
    return (
        <div className={`flex justify-between py-2 border-gray-100 ${className}`}>
            <span className="text-gray-600 text-sm">{t('pages.delivery.detail.deliveryMethod')}:</span>
            <span className="text-sm font-medium text-right break-all">{getDeliveryMethodLabelFromConfig(item)}</span>
        </div>
    );
};

export default DeliveryMethodDisplayCard;

